import Icons from "@gstyles/styleguide/icons";
// import { useRouteContext } from "@providers/RouteProvider";
// import { useTranslationContext } from "@providers/TranslationProvider";
import cx from "classnames";
import Link from "@components/Link";
import styles from "./Address.module.scss";
import { usePageContext } from "@providers/PageProvider";
import getter from "@services/StrapiService/getter";
import _ from "lodash";

export default function Address() {
  const { pageData } = usePageContext();
  const hotelAddress = getter.hotelAddress(pageData);
  const mapButton = getter.button(_.get(hotelAddress, "mapButton"));
  const phoneButton = getter.button(_.get(hotelAddress, "phoneButton"));
  const redirectButton = getter.button(_.get(hotelAddress, "redirectButton"));
  return (
    <div data-scroll-section className={cx(styles.section)}>
      <div className={cx(styles.hotelLocation)}>
        <h1 className={cx(styles.name)}>
          {_.get(hotelAddress, "hotelName")}
        </h1>
        <div className={cx(styles.address)}>
          {_.get(hotelAddress, "hotelAddress")}
        </div>
      </div>
      <div className={cx(styles.moreContactInfoWrapper)}>
        <div className="whitespace-nowrap">
          <a href={phoneButton?.href}>{phoneButton?.label}</a>
        </div>
        <div className="text-white">|</div>
        <Link
          // href="https://www.google.com/maps/place/Amanaki+Thao+Dien+Hotel/@10.801858,106.7329191,17z/data=!3m1!4b1!4m9!3m8!1s0x31752724994128d7:0x3af0ae64a058f117!5m2!4m1!1i2!8m2!3d10.801858!4d106.735494!16s%2Fg%2F11n85ftgr1"
          href={mapButton?.href}
          target="_blank"
          rel="noopener"
        >
          <div className={cx(styles.viewMapWrapper)}>
            <div>
              {mapButton?.label}
              {/* {i18n.t("Button.viewMap")} */}
            </div>
            <Icons
              alt="arrow right"
              name="arrow-long-narrow-right"
              color="#af915e"
              className={cx(styles.arrowIconWrapper)}
            />
          </div>
        </Link>

        <div className="text-white">|</div>
        <div className="cursor-pointer">
          <Link href={redirectButton?.href} target="_blank" rel="noopener">
            {redirectButton?.label}
          </Link>
          {/* {i18n.t("Button.contactUs")} */}
        </div>
      </div>
    </div>
  );
}
